import { Skeleton, Typography } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { isEmpty } from 'lodash';
import { forwardRef } from 'react';
// @mui
import 'swiper/css';
import { register } from 'swiper/element/bundle';

import MediaPlayerComponent from './video-player';

interface Props extends BoxProps {
  title?: string;
  subheader?: string;
  list: string[];
  isLoading: boolean;
}
register();

const VideoList = forwardRef(({ title, subheader, list, isLoading, sx, ...other }: Props, ref) => {
  const theme = useTheme();

  return (
    <Box>
      <CardHeader
        title={title ?? 'Trending'}
        sx={{
          p: 0,
          mb: 3,
        }}
      />
      {isLoading && <Skeleton sx={{ borderRadius: 1.5, height: '20rem', flexShrink: 0 }} />}
      {!isLoading && isEmpty(list) && (
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          width={1}
          height="15rem"
        >
          <Typography variant="caption" sx={{ color: theme.palette.grey[50] }}>
            No new video
          </Typography>
        </Stack>
      )}
      <swiper-container
        grab-cursor="true"
        autoplay="true"
        autoplay-disable-on-interaction="true"
        prevent-clicks-propagation="true"
        autoplay-delay="10500"
      >
        {list &&
          list.map((item, index) => (
            <swiper-slide key={index}>
              <MediaPlayerComponent
                src={item}
                viewType="video"
                streamType="on-demand"
                title="title"
                poster=""
                textTracks={[]}
              />
            </swiper-slide>
          ))}
      </swiper-container>
    </Box>
  );
});

export default VideoList;
